import {useThemeValue} from '@gravity-ui/uikit';

import {decode as settingsDecode} from '@yandex-data-ui/wf-settings/decode';

import {WFSettings} from '~shared/models';

import {useStateSelector, useLazyValue} from '~ui/hooks';
import {selectGlobalState} from '~ui/store/slices/global';

export const useDecodedWfSettings = () => {
    const {wfSettings: wfSettingsEncoded} = useStateSelector(selectGlobalState);

    return useLazyValue<WFSettings>(() => {
        try {
            return settingsDecode<WFSettings>(wfSettingsEncoded as string).data;
        } catch (error) {
            console.error('Error while decode wf settings:', error);
            return {};
        }
    }, [wfSettingsEncoded]);
};

export const useWfSettings = (decodedWfSettings: WFSettings, slug: string) => {
    const themeValue = useThemeValue();

    return useLazyValue(() => {
        return Object.assign({}, decodedWfSettings, {
            // Параметр нужен для раскрытия относительных экшенов типа include и tree
            page_path: `/${slug}`,
            UITheme: themeValue,
        });
    }, [decodedWfSettings, slug, themeValue]);
};

export const useCommentsWfSettings = (decodedWfSettings: WFSettings) => {
    const themeValue = useThemeValue();

    return useLazyValue<WFSettings>(() => {
        return Object.assign({}, decodedWfSettings, {
            // убираю ссылки на редактирование секций в комментариях и экшены
            extensions: {
                'wiki-doc': null,
                'wiki-head': null,
            },
            remark: {
                markdown: {commonmark: true},
                woofmd: {
                    actions: false,
                },
            },
            UITheme: themeValue,
        });
    }, [decodedWfSettings, themeValue]);
};

export const useGridWfSettings = (decodedWfSettings: WFSettings, slug: string) => {
    const themeValue = useThemeValue();

    return useLazyValue<WFSettings>(() => {
        return Object.assign({}, decodedWfSettings, {
            remark: {
                woofmd: {
                    actions: decodedWfSettings.remark
                        ? decodedWfSettings.remark.woofmd.actions.filter(
                              (action) => action.name !== 'include',
                          )
                        : [],
                },
            },
            // Параметр нужен для раскрытия относительных экшенов
            page_path: `/${slug}`,
            UITheme: themeValue,
        });
    }, [decodedWfSettings, slug, themeValue]);
};
